import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=3d04776b&scoped=true"
import script from "./BoxInfo.vue?vue&type=script&lang=js"
export * from "./BoxInfo.vue?vue&type=script&lang=js"
import style0 from "./BoxInfo.vue?vue&type=style&index=0&id=3d04776b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d04776b",
  null
  
)

export default component.exports